import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ReturnsIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M10.19 8.107a.5.5 0 0 0-.074.073l-.006.007a.5.5 0 0 0 .073.7l5.997 4.997a.5.5 0 0 0 .64-.768L11.881 9H17.5a5.5 5.5 0 1 1 0 11H.5a.5.5 0 0 0 0 1h17a6.5 6.5 0 1 0 0-13h-5.619l4.94-4.116a.5.5 0 1 0-.641-.768l-5.99 4.991Z" />
  </IconWrapper>
)

export default ReturnsIconMedium
